import loadScript from "./load-script";

const GOOGLE_AUTH_PLATFORM_SCRIPT = "https://apis.google.com/js/api:client.js";
const GOOGLE_AUTH_CONFIG = {
  client_id: process.env.GOOGLE_CLIENT_ID,
  cookiepolicy: "single_host_origin",
  scope: "https://www.googleapis.com/auth/spreadsheets",
};

// googThenables, the promise-like objects used by the google sdk
// are not compatible with native Promises, and result in infinite loops
// when simply calling googlThenable.then(resolve, reject).
function fixPromise(googThenable, resolve, reject) {
  googThenable.then(
    args => {
      resolve(...args);
    },
    args => {
      reject(...args);
    }
  );
}

function _loadGAuth() {
  return loadScript(GOOGLE_AUTH_PLATFORM_SCRIPT).then(() => {
    return new Promise((resolve, reject) => {
      gapi.load("auth2", function() {
        fixPromise(gapi.auth2.init(GOOGLE_AUTH_CONFIG), resolve, reject);
      });
    });
  });
}

export function loadGAuth() {
  return (window.gapi && Promise.resolve()) || _loadGAuth();
}

export function signIn() {
  return loadGAuth().then(() => {
    return new Promise((resolve, reject) => {
      const auth = gapi.auth2.getAuthInstance();
      const resolveUserProfile = () => resolve(auth.currentUser.get());

      try {
        if (auth.isSignedIn.get()) resolveUserProfile();
        else {
          auth.isSignedIn.listen(resolveUserProfile);
          auth.signIn();
        }
      } catch (error) {
        reject(error);
      }
    });
  });
}

export function signOut() {
  return loadGAuth().then(() => {
    return new Promise((resolve, reject) => {
      const auth = gapi.auth2.getAuthInstance();
      fixPromise(auth.signOut(), resolve, reject);
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/google-auth.js